import { Controller } from "@hotwired/stimulus"
import { put } from "@rails/request.js";

export default class extends Controller {
  static targets = ["input", "span", "placeholder", "editBtn", "updateBtn"];
  static values = {
    text: String,
    url: String,
  }

  connect(){
    this.inputTarget.style.width = this.spanTarget.offsetWidth + "px";
  }

  startEditing() {
    this.inputTarget.style.width = this.spanTarget.offsetWidth + "px";

    this.placeholderTarget.classList.add("hidden");
    this.inputTarget.classList.remove("hidden");
    this.editBtnTarget.classList.add("hidden");
    this.updateBtnTarget.classList.remove("hidden");
    this.inputTarget.focus();

    const length = this.inputTarget.value.length;
    this.inputTarget.setSelectionRange(length, length);
  }

  async updateTitle() {
    const title = this.inputTarget.value;

    await put(this.urlValue, {
      responseKind: "turbo-stream",
      body: {
        "course_section": {
          "title": title,
        }
      }
    });

    this.placeholderTarget.classList.remove("hidden");
    this.inputTarget.classList.add("hidden");
    this.editBtnTarget.classList.remove("hidden");
    this.updateBtnTarget.classList.add("hidden");
  }

  updateWidth(e) {
    this.spanTarget.textContent = e.target.value || "";
    this.inputTarget.style.width = this.spanTarget.offsetWidth + "px";
  }
}
